/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import CampaignModel, { CampaignState } from 'cio/models/campaign';
import { inject as service } from '@ember/service';
import AnalyticsService from 'cio/services/analytics';
import RouteInfo from '@ember/routing/-private/route-info';
import { SerializedLegacySegmentNegatableFilter } from 'cio/types/conditions/legacy-filter';
import DS from 'ember-data';
import { task } from 'ember-concurrency';

interface SegmentArgs {
  campaign: CampaignModel;
  anchors: Record<string, unknown>[];
  filters: Record<string, unknown>[];
  restartMode: string;
  restartMinInterval: number;
  updateTriggers: (conditions: Record<string, unknown>) => unknown;
}

export default class Segment extends Component<SegmentArgs> {
  @service analytics!: AnalyticsService;
  @service store!: DS.Store;

  conditionTypes = Object.freeze(['segments', 'segments_negatable']);

  constructor(owner: unknown, args: SegmentArgs) {
    super(owner, args);
    this.fetchSegments.perform();
  }

  @action
  trackSegmentCreationStartedFrom(source: RouteInfo) {
    this.analytics.track('segment', 'creation_started', { source });
  }

  get segmentIds(): (number | string)[] {
    let { isSegmentTriggered, anchors } = this.args.campaign;
    if (!isSegmentTriggered) {
      return [];
    }
    return anchors.flatMap((anchor: SerializedLegacySegmentNegatableFilter) => anchor.segments ?? []);
  }

  get showRelationshipSegmentHistoricalDataTriggerWarning() {
    let { isSegmentTriggered, backfill, state } = this.args.campaign;
    if (isSegmentTriggered && !backfill && state !== CampaignState.Draft) {
      let originalSegmentIds = this.args.campaign.anchors.flatMap(
        (anchor: SerializedLegacySegmentNegatableFilter) => anchor.segments ?? [],
      );
      // if original trigger didn't have any relationship segment
      if (!originalSegmentIds.some((id) => this.store.peekRecord('short-segment', id)?.hasRelationshipConditions)) {
        let currentSegmentIds = this.args.anchors.flatMap(
          (anchor: SerializedLegacySegmentNegatableFilter) => anchor.segments ?? [],
        );
        let someSegmentHasRelationshipCondition = currentSegmentIds.some(
          (id) => this.store.peekRecord('short-segment', id)?.hasRelationshipConditions,
        );
        return someSegmentHasRelationshipCondition;
      }
    }
    return false;
  }

  fetchSegments = task(async () => {
    if (this.store.peekAll('short-segment').length === 0) {
      await this.store.findAll('short-segment');
    }
  });
}
